import { render, staticRenderFns } from "./MuteIcon.vue?vue&type=template&id=160946a0&scoped=true&"
import script from "./MuteIcon.vue?vue&type=script&lang=js&"
export * from "./MuteIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160946a0",
  null
  
)

export default component.exports